import React, { useState, useEffect } from 'react';

const EditNote = ({ endpoint, deleteEndpoint, initialNote }) => {
  const [note, setNote] = useState(initialNote || ''); // Inicializace poznámky
  const [message, setMessage] = useState('');

  useEffect(() => {
    setNote(initialNote || ''); // Aktualizace poznámky při změně `initialNote`
  }, [initialNote]);

  const handleSave = async () => {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note }),
      });

      const data = await response.json();
      setMessage(data.message || 'Poznámka byla úspěšně uložena.');
    } catch (error) {
      console.error('Chyba při ukládání poznámky:', error);
      setMessage('Chyba při ukládání poznámky.');
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Opravdu chcete smazat poznámku?')) {
      try {
        const response = await fetch(deleteEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setMessage(data.message || 'Poznámka byla úspěšně smazána.');
        setNote(''); // Vyprázdnit poznámku v poli po úspěšném smazání
      } catch (error) {
        console.error('Chyba při mazání poznámky:', error);
        setMessage('Chyba při mazání poznámky.');
      }
    }
  };

  return (
    <div className="edit-note">
      <h2>Editace poznámky</h2>
      <textarea
        className="w-full p-2 border"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Zadejte poznámku..."
        rows={6}
      />
      <div className="mt-4">
        <button
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 mr-2"
          onClick={handleSave}
        >
          Uložit poznámku
        </button>
        <button
          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
          onClick={handleDelete}
        >
          Smazat poznámku
        </button>
      </div>
      {message && <p className="mt-4">{message}</p>}
    </div>
  );
};

export default EditNote;